import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Site } from './site';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { SiteSearchResult } from './siteSearchResult';
import { SiteSearchQuery } from './siteSearchQuery';

@Injectable({
  providedIn: 'root'
})
export class SiteApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getSite(siteId: number): Observable<Site> {
    return this.http.get<Site>(`${this.apiUrl}/api/v6/sites/${siteId}`).pipe(
      catchError(this.handleError<Site>('getSite', undefined))
    );
  }

  searchSites(params: SiteSearchQuery): Observable<SiteSearchResult[]> {
    return this.http.post<SiteSearchResult[]>(`${this.apiUrl}/api/v6/sites/search`, params).pipe(
      catchError(this.handleError<SiteSearchResult[]>('searchSites', []))
    );
  }
}
